import logo from './logo.svg';
import './App.css';
import NavBar from './NavBar';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <NavBar items={[{name:"HOME",url:"index.html"},{name:"ABOUT",url:"index.html"}]}/>
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Hello World!
        </p>
        
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>
    </div>
  );
}

export default App;
